/**
 * Merge logic for reconciling a grid's committed quickFilter value into a
 * locally-typed search input.
 *
 * A DataGridPro's `filterModelChange` can fire while the user is still
 * typing (initial sessionStorage restore, or a commit the user themselves
 * just triggered). Comparing the grid's value against the raw typed value
 * with plain equality would overwrite in-flight keystrokes whenever they
 * differ only by whitespace the user hasn't finished entering yet (a
 * trailing space, a second space before the next word) — the commit path
 * already collapses that whitespace via split/filter, so "hello " and the
 * grid's "hello" represent the same committed query. Normalizing the local
 * value the same way before comparing keeps those keystrokes alive.
 *
 * Contains:
 * - mergeQuickFilterSync — (prev, next) => value to keep as the input's state
 */

export function mergeQuickFilterSync(prev, next) {
  const normalizedPrev = prev.split(/\s+/).filter(Boolean).join(' ');
  return normalizedPrev === next ? prev : next;
}
